import { ReactNode } from 'react';
import { ICustomColumnType } from 'shared/ui/VirtualTable';
import getUserTableNameCell from './ui/getUserTableNameCell';
import { DataType } from './UserTable.types';

export const PAGE_SIZE = 40;
export const THRESHOLD_VALUE = 5;
export const ROW_HEIGHT = 39;

export const columns: ICustomColumnType<DataType>[] = [
  {
    title: 'UserOverview:UserTable.header.column.name.title',
    dataIndex: 'name',
    key: 'firstName',
    ellipsis: {
      showTitle: false,
    },
    sorter: true,
    minWidth: 250,
    width: '16%',
    render: getUserTableNameCell,
  },
  {
    title: 'UserOverview:UserTable.header.column.seniority.title',
    dataIndex: 'seniority',
    key: 'seniority',
    ellipsis: {
      showTitle: false,
    },
    sorter: true,
    minWidth: 150,
    width: '10.5%',
  },
  {
    title: 'UserOverview:UserTable.header.column.specialization.title',
    dataIndex: 'specialization',
    key: 'specialization',
    ellipsis: {
      showTitle: false,
    },
    sorter: true,
    minWidth: 150,
    width: '10.5%',
  },
  {
    title: 'UserOverview:UserTable.header.column.workProfile.title',
    dataIndex: 'workProfile',
    key: 'workProfile',
    ellipsis: {
      showTitle: false,
    },
    sorter: true,
    minWidth: 150,
    width: '10.5%',
  },
  {
    title: 'UserOverview:UserTable.header.column.manager.title',
    dataIndex: 'managerBamboo',
    key: 'managerBamboo',
    ellipsis: {
      showTitle: false,
    },
    sorter: true,
    minWidth: 150,
    width: '10.5%',
  },
  {
    title: 'UserOverview:UserTable.header.column.email.title',
    dataIndex: 'email',
    key: 'email',
    ellipsis: {
      showTitle: false,
    },
    sorter: true,
    minWidth: 150,
    width: '10.5%',
  },
  {
    title: 'UserOverview:UserTable.header.column.location.title',
    dataIndex: 'location',
    key: 'location',
    ellipsis: {
      showTitle: false,
    },
    sorter: true,
    minWidth: 150,
    width: '10.5%',
  },
  {
    title: 'UserOverview:UserTable.header.column.employmentType.title',
    dataIndex: 'employmentType',
    key: 'employmentType',
    ellipsis: {
      showTitle: false,
    },
    sorter: true,
    minWidth: 150,
    width: '10.5%',
  },
  {
    title: 'UserOverview:UserTable.header.column.engaged.title',
    dataIndex: 'engaged',
    key: 'engaged',
    ellipsis: {
      showTitle: false,
    },
    sorter: true,
    minWidth: 150,
    width: '10.5%',
    render: (engaged: boolean): ReactNode => {
      return engaged ? 'Engaged' : 'Disengaged';
    },
  },
];
